// extracted by mini-css-extract-plugin
export var blurb = "contact-module--blurb--470e4";
export var content = "contact-module--content--d0bed";
export var flower = "contact-module--flower--cca5b";
export var paw = "contact-module--paw--3c0af";
export var squiggle = "contact-module--squiggle--d85ba";